import React, { useState, useRef, useEffect, useContext } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import DivLoader from "components/divloader/DivLoader";
import { FaChevronDown } from "react-icons/fa";
import { useOnClickOutsideSingel } from "utils/useOnClickOutside";
import { MultiSelect } from "react-multi-select-component";
import { ClientContext } from "ClientProvider";
import { getAllGatewaysOrg } from "api/graphQL_gateways";

interface OrgGateway { gatewayId: string; gatewayName: string; }
interface OrgGatewaysResponse { gateways: OrgGateway[]; }

const ClientPayment = ({
  Organization, slectedOrg, assignPaymentMethod, showPaymnets = true,
  handleSelectionChange, errorclass, methodName, viewMode, allGateways, formData,
}: {
  Organization?: any; slectedOrg?: string; assignPaymentMethod?: any;
  showPaymnets?: boolean; handleSelectionChange: any; errorclass?: boolean;
  methodName?: boolean; viewMode?: boolean; allGateways: any; formData: any;
}) => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = React.useState([]);
  const [options, setGatewayOption] = React.useState([]);
  const [allGatewaysOrg, setAllGatewaysOrg] = React.useState([]);
  const { singleRoleData } = useContext(ClientContext);

  const handleChildChange = (e: any) => { setSelected(e); handleSelectionChange(e); };

  React.useEffect(() => {
    if (selected && assignPaymentMethod.length > 0 && allGatewaysOrg.length > 0) {
      const opt = assignPaymentMethod.map((ele: any) => {
        const gateway = allGatewaysOrg?.find((item: any) => item.id === ele.value);
        return { value: ele.value, label: singleRoleData[0]?.client?.value?.client_show_method_name ? gateway?.name : ele.label };
      });
      setSelected(opt);
    }
    let gatewayData: any = [];
    if (Organization !== undefined && allGatewaysOrg.length > 0) {
      Organization.map((ele: any) => {
        const gateway = allGateways?.find((item: any) => item.id === ele);
        if (gateway) { const data = { value: ele, label: singleRoleData[0]?.client?.value?.client_show_method_name ? gateway?.name : ele }; gatewayData.push(data); }
      });
      setGatewayOption(gatewayData);
    }
  }, [Organization, allGatewaysOrg]);

  useEffect(() => {
    if (allGatewaysOrg.length > 0) {
      setGatewayOption(allGatewaysOrg.map((ele: any) => ({
        ...ele, value: ele.id,
        label: singleRoleData[0]?.client?.value?.client_show_method_name ? ele?.name : ele?.id,
      })));
    } else { setGatewayOption([]); }
  }, [allGatewaysOrg]);

  const fetchOrgGateways = (org_id: any) => {
    getAllGatewaysOrg(org_id)
      .then((data: OrgGatewaysResponse) => {
        if (data.gateways.length > 0) {
          setAllGatewaysOrg(data.gateways.map(({ gatewayId, gatewayName }) => ({ id: gatewayId, name: gatewayName })));
        } else { setAllGatewaysOrg([]); setSelected([]); }
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  useEffect(() => { if (formData.org_id != "") fetchOrgGateways(formData.org_id); }, [formData.org_id]);

  return (
    <>
      {slectedOrg !== "" ? (
        <div className="cp-wrap">
          <label className="cp-label">Gateways*</label>
          <div className="cp-multiselect-wrap">
            <MultiSelect
              options={options}
              value={selected}
              onChange={handleChildChange}
              labelledBy="Select"
              disabled={viewMode}
              className={errorclass === false ? " " : viewMode === true ? "disableClass" : ""}
              overrideStrings={{ noOptions: "Gateway not found!" }}
              valueRenderer={(selected, options) => {
                if (selected.length === 0) return "Select gateway";
                if (selected.length === options.length) return "All gateways selected";
                return selected.map((o) => o.label).join(", ");
              }}
            />
          </div>
          {errorclass && <></>}
        </div>
      ) : (
        <label className="cp-label cp-label--empty">No Payment Gateways</label>
      )}

      <style>{`
        .cp-wrap {
          display: flex; flex-direction: column; gap: 6px;
          margin-top: 8px; margin-bottom: 8px;
          min-width: 0; width: 100%;
        }
        .cp-label {
          font-size: 13px; font-weight: 700; color: #111827;
          padding-left: 2px; display: block;
        }
        .cp-label--empty { color: #6b7280; font-weight: 600; }

        /* Constrain the MultiSelect — never grows wider than parent */
        .cp-multiselect-wrap {
          /* table-layout trick: forces block to respect parent width strictly */
          display: table !important;
          table-layout: fixed !important;
          width: 100% !important;
          min-width: 0 !important;
          position: relative;
        }

        /* react-multi-select-component overrides */
        .cp-multiselect-wrap .dropdown-container {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          border: 1.5px solid #e2e8f0 !important;
          border-radius: 10px !important;
          background: #f8fafc !important;
          font-size: 13px !important;
          overflow: visible !important;
        }
        .cp-multiselect-wrap .dropdown-container:focus-within {
          border-color: #16a34a !important;
          box-shadow: 0 0 0 3px rgba(22,163,74,0.1) !important;
        }
        /* The heading row — clips text, never grows in height or width */
        .cp-multiselect-wrap .dropdown-heading {
          display: flex !important;
          align-items: center !important;
          height: 42px !important;
          min-height: 42px !important;
          max-height: 42px !important;
          padding: 0 12px !important;
          /* overflow:hidden here clips ONLY the heading text, not the panel below */
          overflow: hidden !important;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        /* Value wrapper inside heading */
        .cp-multiselect-wrap .dropdown-heading-value {
          flex: 1 1 0% !important;
          min-width: 0 !important;
          max-width: 100% !important;
          overflow: hidden !important;
        }
        /* The actual text span — truncate with ellipsis */
        .cp-multiselect-wrap .dropdown-heading-value span,
        .cp-multiselect-wrap .dropdown-heading-value > * {
          display: block !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          white-space: nowrap !important;
          width: 100% !important;
          font-size: 13px !important;
          color: #0f172a !important;
        }
        /* Dropdown panel — must escape the container, not be clipped */
        .cp-multiselect-wrap .dropdown-content {
          z-index: 9999 !important;
          border: 1.5px solid #e2e8f0 !important;
          border-radius: 10px !important;
          box-shadow: 0 8px 24px rgba(15,23,42,0.12) !important;
          /* overflow visible so options list shows */
          overflow: visible !important;
          position: absolute !important;
          width: 100% !important;
        }
        .cp-multiselect-wrap .options {
          max-height: 200px !important;
          overflow-y: auto !important;
        }
        .cp-multiselect-wrap .options li label {
          font-size: 13px !important;
          color: #374151 !important;
        }
        .cp-multiselect-wrap input[type="text"] {
          font-size: 13px !important;
        }

        /* Mobile */
        @media (max-width: 480px) {
          .cp-multiselect-wrap .dropdown-heading { height: 40px !important; }
          .cp-multiselect-wrap .dropdown-heading-value { font-size: 12px !important; }
          .cp-multiselect-wrap .dropdown-container { font-size: 12px !important; }
          .cp-label { font-size: 12px; }
        }
      `}</style>
    </>
  );
};

export default ClientPayment;